import { render, staticRenderFns } from "./Basis.vue?vue&type=template&id=47d95a8a"
import script from "./Basis.vue?vue&type=script&lang=js"
export * from "./Basis.vue?vue&type=script&lang=js"
import style0 from "./Basis.vue?vue&type=style&index=0&id=47d95a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports